import { useState } from "react";
import { useCallback } from "react";
import axios from "utils/axios";

const useAxios = () => {
  const [data, setData] = useState(null);
  const [loadingData, setLoadingData] = useState(true);
  const [error, setError] = useState(null);

  const sendRequest = useCallback((requestConfig, dataFetchedTitle) => {
    setLoadingData(true);
    axios({
      url: requestConfig.url,
      method: requestConfig.method ? requestConfig.method : "GET",
      data: requestConfig.data ? requestConfig.data : null,
      params: requestConfig.params ? requestConfig.params : {},
      headers: requestConfig.headers
        ? // ? {
          //     Authorization: `Bearer tokenvalid`,
          requestConfig.headers
        : // }
          axios.defaults.headers,
    })
      .then((response) => {
        setData(response.data);
        setError(null);
      })
      .catch((err) =>
        setError(
          `Something went wrong while fetching ${
            dataFetchedTitle ? dataFetchedTitle : "data"
          }!`
        )
      )
      .finally(() => setLoadingData(false));
  }, []);

  return { sendRequest, data, loadingData, error };
};

export default useAxios;
